


















import Vue, { PropType } from 'vue'

import { MessageAttachment } from 'base/store/state.interface'

import { FileAttachment } from './file-attachment.interface'

export default Vue.extend({
  props: {
    attachments: Array as PropType<FileAttachment[]>,
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isPreviewable(attachment: FileAttachment): boolean {
      if (!attachment.file) return false

      return attachment.file.type.includes('image')
    },
    fileUrlForAttachment(attachment: FileAttachment): string {
      if (attachment.file) {
        return window.URL.createObjectURL(attachment.file)
      }
      return `/api/v2/file/open?id=${attachment.id}`
    },
    humanizedSizeDescription(attachment: FileAttachment): string {
      if (!attachment.file) return ''
      const size = attachment.file.size

      if (size < 1024) {
        return size + 'B'
      } else if (size >= 1024 && size < 1024 * 1024) {
        return (size / 1024).toFixed(1) + ' KB'
      } else {
        // size >= 1024 * 1024
        return (size / 1024 * 1024).toFixed(1) + ' MB'
      }
    },
    removeAttachmentAtIndex(index: number) {
      if (this.attachments.length <= index) {
        console.error('Try to removing attachment at invalid index')
        return
      }

      this.attachments.splice(index, 1)
    }
  }
})
